module.exports = __webpack_public_path__ + "static/media/icon_empty-state.932d2a3e.svg";